import {createFileRoute} from '@tanstack/react-router';
import {CreditAccountClosePage} from 'features/credit/pages/CreditAccountClosePage/CreditAccountClosePage';

export const Route = createFileRoute(
  '/_protected/accounts/credits/$accountId/close/confirm',
)({
  component: CreditAccountClosePage,
});
